import React, { useSyncExternalStore, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { Link } from 'react-router-dom';
// import { Container, Row, Col, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import CookieConsent from 'react-cookie-consent';

import config from '../../../../config';
import { isEmbedded } from '../../AppActions';

import withIntl from '../../../../components/Intl/WithIntl';
import CmsPanel from '../../../Cms/components/content/CmsPanel';
import SupportChat from '../Support/SupportChat';
// import UserAdminLoginSwitcher from '../../../User/components/admin/UserAdminLoginSwitcher';

// Import Style

function Footer({ intl, isEmbedded = false }) {
	// True only after client-side hydration, so the version isn't rendered during SSR.
	const isMounted = useSyncExternalStore(() => () => {}, () => true, () => false);

	return (
		<footer className="sticky-footer bg-white border-top">
			<div className="container my-auto">
				{!isEmbedded && (
					<Fragment>
						<p className="p-3 text-center">
							<img src={`${config.staticUrl}images/app/logo-alt.png`} alt={config.application.name} /><br />
						</p>
						<div className="copyright text-center my-auto">
							&copy; {new Date().getFullYear()} &middot; {config.application.name} <small>v.{isMounted && config.version}</small><br />
						</div>
						<div className="copyright text-center my-auto" style={{ fontSize: '0.8rem' }}>
							{/* <a href="/page/cgu"><FormattedMessage id="appLinkCGU" defaultMessage="Terms of use" /></a>{' - '}
							<a href="https://managexam.com/mentions-legales/" target="_blank" rel="noreferrer"><FormattedMessage id="appLinkLegalMentions" defaultMessage="Legal mentions" /></a>{' - '}
							<a href="https://managexam.com/protection-des-donnees-rgpd/" target="_blank" rel="noreferrer"><FormattedMessage id="appLinkDataProtection" defaultMessage="Data protection" /></a>{' - '}
							<a href="https://managexam.com/politique-des-cookies/" target="_blank" rel="noreferrer"><FormattedMessage id="appLinkCookiePolicy" defaultMessage="Cookie policy" /></a> */}
							<CmsPanel slug="footer-links" locale={intl.locale} />
						</div>
						<div className="copyright text-center mt-2">
							<small lang="en">Made with <FontAwesomeIcon icon="coffee" /> by <a href="https://offaxis.io" className="text-gray-900" target="_blank" rel="noreferrer">OFF<strong style={{ color: '#D90000' }}>/</strong>AXIS</a></small>
						</div>
					</Fragment>
				)}
				{/* <UserAdminLoginSwitcher /> */}
				<SupportChat />
			</div>
			{/* <CookieConsent
                buttonText="OK"
                buttonClasses="btn btn-outline-primary btn-sm"
                buttonStyle={{}}
            >
                <FormattedMessage id="appCookieConsentText" defaultMessage="By continuing your visit to this site, you accept the use of cookies for the purposes of the functioning of the proposed service and statistics. No personal data will be communicated without your prior consent." />
                {' '}<Button size="sm" color="warning" outline tag="a" href="https://managexam.com/mentions-legales/" target="_blank"><FormattedMessage id="appCookieConsentPrivacyLink" defaultMessage="See our privacy policy" /></Button>
            </CookieConsent> */}
		</footer>
	);
}
function mapStateToProps(store, props) {
	return {
		isEmbedded: isEmbedded(store),
	};
}
Footer.propTypes = {
	intl: PropTypes.object.isRequired,
	isEmbedded: PropTypes.bool,
};

export default connect(mapStateToProps)(withIntl(Footer));
